import { render, staticRenderFns } from "./p-card.vue?vue&type=template&id=442419e2&scoped=true&"
import script from "./p-card.vue?vue&type=script&lang=js&"
export * from "./p-card.vue?vue&type=script&lang=js&"
import style0 from "./p-card.vue?vue&type=style&index=0&id=442419e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442419e2",
  null
  
)

export default component.exports